import { OfficePayrollProfile } from "../../../../settlement/src/officepayroll/OfficePayrollProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: OfficePayrollProfile;
    panelHeader: Panel;
    sourceOfficePayrollProfile: DataSource;
}
